import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { ObservacoesLaudosModel } from "./observacoes-laudos.model";
import { ObservacoesLaudosService } from './observacoes-laudos.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";

@Component({
  selector: 'app-observacoes-laudos-form',
  templateUrl: './observacoes-laudos-form.component.html'
})
export class ObservacoesLaudosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  observacao: ObservacoesLaudosModel = new ObservacoesLaudosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listCores = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private observacoesLaudosService: ObservacoesLaudosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      observacao_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(5000)
      ]],
      observacao_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(5000)
      ]],
      observacao_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(5000)
      ]],
      cor: [null]
    });

    this.listCores = [{
      "nome": "Verde",
      "valor": 1
    },{
      "nome": "Amarelo",
      "valor": 2
    },{
      "nome": "Vermelho",
      "valor": 0
    }];
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_observacao'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarObservacao');
      } else {
        this.title = id ? this.func.traduzir('front.editarObservacao') : this.func.traduzir('front.addObservacao');
      }

      if (!id) {
        return;
      }

      this.observacoesLaudosService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarObservacao') + ': ' + json.Payload[0].observacao_pt;
            } else {
              this.title = this.func.traduzir('front.visualizarObservacao') + ': ' + json.Payload[0].observacao_pt;
            }

            this.observacao = json.Payload[0];

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.observacoesLaudosService.editar(values, values.id);
    } else {
      result = this.observacoesLaudosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-cd', 'observacoes']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if (json.Message && json.Message.ErrorInput) {
          for (let i in json.Message.ErrorInput) {
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-observacoes/observacoes-laudos-form.component.ts